import { render, staticRenderFns } from "./import_excel.vue?vue&type=template&id=20633ffe&scoped=true&"
import script from "./import_excel.vue?vue&type=script&lang=js&"
export * from "./import_excel.vue?vue&type=script&lang=js&"
import style0 from "./import_excel.vue?vue&type=style&index=0&id=20633ffe&scoped=true&lang=css&"
import style1 from "./import_excel.vue?vue&type=style&index=1&id=20633ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20633ffe",
  null
  
)

export default component.exports